import React from "react";

const CostcoBlueLoader = (props: { loadingText?: string }) => (
  <div className="flex flex-grow items-center justify-center z-10">
    <div className="flex flex-col items-center">
      <div className="w-16 h-16 flex items-center justify-center">
        <span className="icon-sync animate-spin text-blue-600 text-5xl" />
      </div>
      {props.loadingText && (
        <div className="pt-4 text-lg text-center font-medium text-gray-700">
          {props.loadingText}
        </div>
      )}
    </div>
  </div>
);

export default CostcoBlueLoader;
